<template>
	<span>
		<div class="col-md-10">
			<a @click="navigatoToBuyCredit"> Seus créditos estão acabando, faça uma recarga! <strong> Saldo: {{ this.alert.balance | money }} </strong>  </a>
			<br>
		</div>
		<div class="col-md-1" @click="close">
			<i class="fa fa-window-close icon"></i> 
		</div>
		
		<div class="space-50"></div>
		<small class="pull-right">{{ alert.date | time }}</small>
	</span>
</template>

<script>
  export default {
    name: 'BalanceAlertNotification',
    props: {
      alert: {
        type: Object,
        required: true
      }
    },
    methods: {
      close () {
        this.$emit('decreaseNotification', this.alert)
      },
      navigatoToBuyCredit () {
        this.$router.push({name: 'finances_dashboard', query: { buy_credit: true }})
        this.$emit('decreaseNotification', this.alert)
      }
    }
  }
</script>

<style scoped>
  a {
    color: #777777;
  }

  
  .icon {
    color: #189ce2;
    border-color: #168ccb;
    font-size: 1.8rem;
	margin: -5px;
  }

</style>



// WEBPACK FOOTER //
// BalanceAlertNotification.vue?2f6deaf9